import { TabPressedEvents } from "@/constants/analytics/Tabs";
import { TabPath } from "@/constants/Navigation";
import { useAppSelector } from "@/store/hooks";
import { selectNotifications } from "@/store/reducers/notifications";
import { FAIconName } from "@/ui/core";

interface TabScreenProps {
  analyticsEvent: ValueOf<typeof TabPressedEvents>;
  icon: FAIconName;
  notificationCount?: number;
  pathName: string;
  title: string;
}

const useTabScreens = () => {
  const notifications = useAppSelector(selectNotifications);

  const tabScreens: TabScreenProps[] = [
    {
      analyticsEvent: TabPressedEvents.Home,
      icon: FAIconName.Home,
      notificationCount: notifications.homeBadgeCount,
      pathName: "(home)",
      title: "Home",
    },
    {
      analyticsEvent: TabPressedEvents.Schedule,
      icon: FAIconName.Calendar,
      notificationCount: notifications.scheduleBadgeCount,
      pathName: TabPath.Schedule,
      title: "Schedule",
    },
    {
      analyticsEvent: TabPressedEvents.Messages,
      icon: FAIconName.Message,
      notificationCount: notifications.messagesBadgeCount,
      pathName: TabPath.Messages,
      title: "Messages",
    },
    {
      analyticsEvent: TabPressedEvents.Explore,
      icon: FAIconName.BookOpenReader,
      notificationCount: notifications.resultsBadgeCount,
      pathName: "(explore)",
      title: "Explore",
    },
    {
      analyticsEvent: TabPressedEvents.Profile,
      icon: FAIconName.UserCircle,
      notificationCount: notifications.profileBadgeCount,
      pathName: "(profile)",
      title: "Profile",
    },
  ];

  return tabScreens;
};

export default useTabScreens;
